import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=06bd6491&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=06bd6491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd6491",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bd6491')) {
      api.createRecord('06bd6491', component.options)
    } else {
      api.reload('06bd6491', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=06bd6491&scoped=true&", function () {
      api.rerender('06bd6491', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27QB7kIt6xtbl/JS/comp/GuestBox.vue"
export default component.exports